import { ONBOARDING_PALETTE } from '@/pages/onboarding/_components/onboarding-palette';
import { OnboardingPanelFrame } from '@/pages/onboarding/_components/panel/OnboardingPanelFrame';
import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthNewsCarousel } from './AuthNewsCarousel';

const NEWS_PANEL_COLORS = ['discoveryAccent', 'lilac.300', 'green.300', 'rose.200'] as const;

/** Brand panel continuous with the first onboarding step, hidden on mobile. */
export const AuthBrandPanel = () => {
  const { t } = useTranslation();
  const [slide, setSlide] = useState(0);

  return (
    <OnboardingPanelFrame bg={NEWS_PANEL_COLORS[slide]}>
      <Flex
        flex={1}
        direction="column"
        justify="center"
        gap={{ lg: '28px', xl: '34px' }}
        maxW="500px"
      >
        <Box>
          <Heading
            as="h2"
            fontFamily="heading"
            fontSize={{ lg: '36px', xl: '44px' }}
            lineHeight="1.12"
            fontWeight="700"
            letterSpacing="-0.03em"
            color="primary.900"
          >
            {t('authPage.brandHeading')}
          </Heading>
          <Text
            fontFamily="body"
            fontSize="16px"
            lineHeight="1.55"
            color="primary.900"
            mt="18px"
            fontWeight="400"
          >
            {t('authPage.brandSubtext')}
          </Text>
        </Box>

        <Box
          p="12px"
          borderRadius="32px"
          bg={ONBOARDING_PALETTE.cardsTray}
          borderWidth="1px"
          borderColor={ONBOARDING_PALETTE.cardsTrayBorder}
        >
          <AuthNewsCarousel onSlideChange={setSlide} accentColor={NEWS_PANEL_COLORS[slide]} />
        </Box>
      </Flex>
    </OnboardingPanelFrame>
  );
};
